/* eslint-disable */
import * as THREE from 'three'
import a from './r.js'
import r1 from './r1.js'
import u from './deep1.js'
import oo from './rr.js'
import s from './deep2.js'
import l from './deep6.js'

var c = function (e) {
  function r(e) {
    !function (e, t) {
      if (!(e instanceof t))
        throw new TypeError("Cannot call a class as a function")
    }(this, r);
    var t = e.querySelector("canvas.displacement")
      , n = function (e, t) {
        if (!e)
          throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return !t || "object" != typeof t && "function" != typeof t ? e : t
      }(this, (r.__proto__ || Object.getPrototypeOf(r)).call(this, "jellyfishes", t, {
        camera: {
          type: "perspective"
        },
        renderer: {
          alpha: !1,
          bgColor: "#05111f"
        }
      }));
    n.ref = e,
      n.mouseRatio = {
        x: 0,
        y: 0
      },
      n.ratio = {
        x: 0,
        y: 0
      },
      n.visibleOffset = 0,
      n.scrollRatio = 0,
      n.fogNearFar = {
        near: n.app.camera.position.z - 5,
        far: n.app.camera.position.z + 20
      },
      n.app.scene.fog = new THREE.Fog(85400, n.fogNearFar.near, n.fogNearFar.far),
      n.app.camera.position.z = 10,
      n.particlesSystem = new s.default(n.app.scene),
      n.app.scene.add(n.particlesSystem.container),
      n.particlesSystem.container.z = -1,
      n.jellys = [],
      n.jellys[0] = new u.default("/images/medusas-1-p2.png", {
        w: 443,
        h: 646,
        depth: 2.5,
        ox: -730,
        oy: 115,
        angle: -10
      }),
      n.jellys[1] = new u.default("/images/medusas-3-p2.png", {
        w: 262,
        h: 422,
        depth: 6,
        ox: -200,
        oy: 280,
        angle: -20
      }),
      n.jellys[2] = new u.default("/images/medusas-5-p2.png", {
        w: 151,
        h: 220,
        depth: 15,
        ox: 350,
        oy: -290,
        angle: 0
      }),
      n.jellys[3] = new u.default("/images/medusas-3-p2.png", {
        w: 262,
        h: 422,
        depth: 4,
        ox: 800,
        oy: 180,
        angle: -15
      }),
      n.jellys[4] = new u.default("/images/medusas-3-p2.png", {
        w: 262,
        h: 422,
        depth: 6,
        ox: -420,
        oy: -200,
        angle: 10
      });
    for (var i = 0; i < n.jellys.length; i++)
      n.app.scene.add(n.jellys[i]);
    return n.jellyFish = new l.default("texture-meduses-p2.png", "map-meduses-p2.jpg", {
      w: 521,
      h: 760
    }),
      n.app.scene.add(n.jellyFish),
      n.resize(),
      n.render(),
      n
  }
  return function (e, t) {
    if ("function" != typeof t && null !== t)
      throw new TypeError("Super expression must either be null or a function, not " + typeof t);
    e.prototype = Object.create(t && t.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }),
      t && (Object.setPrototypeOf ? Object.setPrototypeOf(e, t) : e.__proto__ = t)
  }(r, a.default),
    r1(r, [{
      key: "display",
      value: function () {
        oo(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "display", this).call(this);
        for (var e = 0; e < this.jellys.length; e++)
          this.jellys[e].display(.2 + .1 * e);
        this.jellyFish.display()
      }
    }, {
      key: "hide",
      value: function () {
        oo(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "hide", this).call(this);
        for (var e = 0; e < this.jellys.length; e++)
          this.jellys[e].hide();
        this.jellyFish.hide(),
          oo(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "render", this).call(this)
      }
    }, {
      key: "render",
      value: function () {
        this.mouseRatio.x = window.mouse.x / this.view.width * 2 - 1,
          this.mouseRatio.y = window.mouse.y / this.view.height * 2 - 1,
          this.ratio.x += .05 * (this.mouseRatio.x - this.ratio.x),
          this.ratio.y += .05 * (this.mouseRatio.y - this.ratio.y),
          this.visibleOffset = Math.max(0, window.currentScrollTop + 200 - this.offsetTop),
          this.scrollRatio += .1 * (this.visibleOffset / this.view.offsetHeight - .5 - this.scrollRatio);
        for (var e = 0; e < this.jellys.length; e++)
          this.jellys[e].parallax(this.ratio, this.scrollRatio);
        this.particlesSystem.render(),
          this.jellyFish.render(this.scrollRatio),
          oo(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "render", this).call(this)
      }
    }, {
      key: "resize",
      value: function () {
        var e = window.w
          , t = window.h;
        this.jellyFish.resize();
        for (var n = 0; n < this.jellys.length; n++)
          this.jellys[n].resize(1);
        this.locate(),
          this.app.resize(e, t),
          this.particlesSystem.container.material.uniforms.resolution.value.x = window.w,
          this.particlesSystem.container.material.uniforms.resolution.value.y = window.h,
          this.ref.style.height = this.view.offsetHeight + "px"
      }
    }, {
      key: "dispose",
      value: function () {
        for (var e = 0; e < this.jellys.length; e++)
          this.app.scene.remove(this.jellys[e]),
            this.jellys[e].dispose(),
            this.jellys[e] = null;
        this.jellys = null,
          this.app.scene.remove(this.jellyFish),
          this.jellyFish.dispose(),
          this.jellyFish = null,
          this.app.scene.remove(this.particlesSystem.container),
          this.fogNearFar = null,
          this.particlesSystem.dispose(),
          this.particlesSystem = null,
          this.render = this.resize = null,
          this.app.dispose(),
          this.app = null,
          this.mouseRatio = null,
          this.ratio = null,
          this.visibleOffset = null,
          this.scrollRatio = null,
          oo(r.prototype.__proto__ || Object.getPrototypeOf(r.prototype), "dispose", this).call(this)
      }
    }]),
    r
}();

export default c
